import { Platform } from '@angular/cdk/platform';

import { Injectable, signal } from '@angular/core';
import { Observable, ReplaySubject } from 'rxjs';
import { tap } from 'rxjs/operators';
import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';

export type Breakpoint = 'xs' | 'sm' | 'md' | 'lg' | 'xl' | '2xl';
export interface IMediaSize {
  minWidth: number;
  maxWidth: number;
}
export interface IBreakPoint extends IMediaSize {
  bp: Breakpoint;
}

export const BreakpointsMediaSize: Record<Breakpoint, IMediaSize> = {
  xs: { minWidth: 0, maxWidth: 479 },
  sm: { minWidth: 480, maxWidth: 767 },
  md: { minWidth: 768, maxWidth: 1023 },
  lg: { minWidth: 1024, maxWidth: 1279 },
  xl: { minWidth: 1280, maxWidth: 1629 },
  '2xl': { minWidth: 1630, maxWidth: 0 }
};
// TODO Rimpiazzare BreakpointsSize con BreakpointsMediaSize
export const BreakpointsSize: IBreakPoint[] = [
  { bp: 'xs', minWidth: 0, maxWidth: 479 },
  { bp: 'sm', minWidth: 480, maxWidth: 767 },
  { bp: 'md', minWidth: 768, maxWidth: 1023 },
  { bp: 'lg', minWidth: 1024, maxWidth: 1279 },
  { bp: 'xl', minWidth: 1280, maxWidth: 1629 },
  { bp: '2xl', minWidth: 1630, maxWidth: 0 }
];

export const Breakpoints =
BreakpointsSize.map((b) =>
`(min-width: ${b.minWidth}px) and (max-width: ${b.maxWidth}px)`.replace(/( and )?\((min|max)-width: 0px\)( and )?/, ''))
.concat(['(max-width: 959.98px) and (orientation: landscape)']);


// {
//   xs: '(max-width: 639.98px)',
//   sm: '(min-width: 640px) and (max-width: 767.98px)',
//   md: '(min-width: 768px) and (max-width: 1023.98px)',
//   lg: '(min-width: 1024px) and (max-width: 1279.98px)',
//   xl: '(min-width: 1280px) and (max-width: 1629.98px)',
//   '2xl': '(min-width: 1620px)',
//   HandsetLandscape: '(max-width: 959.98px) and (orientation: landscape)'
// };

@Injectable({
    providedIn: 'root'
})
export class FuseMatchMediaService
{
  private _onMediaChange = new ReplaySubject<{ matchingAliases: string[]; screen: string }>(1);
  #matchingAliases = signal<string[]>([]);
  matchingAliases = this.#matchingAliases.asReadonly();
  #screen = signal<string>('');
  screen = this.#screen.asReadonly();

    /**
     * Constructor
     *
     * @param {BreakpointObserver} _breakpointObserver
     */
    constructor(
      private _breakpointObserver: BreakpointObserver,
      private platforn: Platform
    ) {

      if (this.platforn.isBrowser) {
        this._breakpointObserver.observe(Breakpoints).pipe(
          tap((state) => {
            const bps = ['xs', 'sm', 'md', 'lg', 'xl', '2xl'];
            // Get the matching breakpoints and use them to fill the subject
            const matchedQueries = Object.entries(state.breakpoints).filter(([query, matches]) => matches);
            const screen = BreakpointsSize[Breakpoints.findIndex((q) => q === matchedQueries[0][0])].bp;
            const matchingAliases = bps.slice(0, bps.indexOf(screen) + 1);
            if (matchedQueries.some(([query]) => Breakpoints.includes(query) && /HandsetLandscape/.test(query))) {
              matchingAliases.push('HandsetLandscape');
            }
            this.#matchingAliases.set(matchingAliases);
            this.#screen.set(screen);
            // Execute the observable
            this._onMediaChange.next({
              matchingAliases,
              screen
            });
          })
        ).subscribe();
      }
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Accessors
  // -----------------------------------------------------------------------------------------------------

  /**
   * Getter for _onMediaChange
   */
  get onMediaChange$(): Observable<{ matchingAliases: string[]; screen: string }> {
    return this._onMediaChange.asObservable();
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Public methods
  // -----------------------------------------------------------------------------------------------------

  /**
   * On media query change
   *
   * @param query
   */
  onMediaQueryChange$(query: string | string[]): Observable<BreakpointState> {
    return this._breakpointObserver.observe(query);
  }

}
